import moment from 'moment';
import {
  CONFIRM_CUSTOM_TIME_RANGE,
  ON_REPORTS_TIME_FILTER_CHANGE,
  ON_REPORTS_CUSTOM_DATE_CHOSEN,
  ON_REPORTS_CUSTOM_DATE_FOCUS_CHANGE,
  ON_CUSTOM_REPORTS_TIME_FILTER_CHANGE,
  ON_CUSTOM_REPORTS_CUSTOM_TIME_CHOSEN,
  ON_CUSTOM_REPORTS_CUSTOM_TIME_FOCUS_CHANGE,
} from '../actions';

const initialState = {
  selectedTime: 'mtd',
  tempTimeRange: {
    startDate: moment().subtract(1, 'month'),
    endDate: moment()
  },
  customTimeRange: {
    startDate: moment().subtract(1, 'month'),
    endDate: moment()
  },
  focusedInput: 'startDate'
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CONFIRM_CUSTOM_TIME_RANGE:
      return Object.assign({}, state, {
        customTimeRange: {
          startDate: action.payload.startDate,
          endDate: action.payload.endDate
        }
      });

    case ON_REPORTS_TIME_FILTER_CHANGE:
      return Object.assign({}, state, {
        selectedTime: action.payload
      });

    case ON_REPORTS_CUSTOM_DATE_CHOSEN:
      return Object.assign({}, state, {
        tempTimeRange: {
          startDate: action.payload.startDate,
          endDate: action.payload.endDate || action.payload.startDate
        }
      });

    case ON_REPORTS_CUSTOM_DATE_FOCUS_CHANGE:
      return Object.assign({}, state, {
        focusedInput: action.payload
      });

    case ON_CUSTOM_REPORTS_TIME_FILTER_CHANGE:
      return Object.assign({}, state, {
        selectedTime: action.payload
      });

    case ON_CUSTOM_REPORTS_CUSTOM_TIME_CHOSEN:
      return Object.assign({}, state, {
        tempTimeRange: {
          startDate: action.payload.startDate,
          endDate: action.payload.endDate || action.payload.startDate
        }
      });

    case ON_CUSTOM_REPORTS_CUSTOM_TIME_FOCUS_CHANGE:
      return Object.assign({}, state, {
        focusedInput: action.payload
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/reports/reducers/selected-time.js